import type { FunctionComponent } from 'react';
import React, { useRef } from 'react';
import styled from 'styled-components';
import type { BoxProps } from '@material-ui/core/Box';
import Box from '@material-ui/core/Box';

/**
 * Mobile button wrapper.
 * Wraps the main submit button on pages (if it exists) to apply mobile styling of 'floating' effect.
 * Note: Behvaiour should follow:
 * 1) On mobile, the main submit button should be 'floating'
 * 2) From 1), when user clicks text input, snap back the button inside component.
 * 3) When user focuses out of input, button should be 'floating' again.
 *
 * There is no definitive method of detecting when mobile soft keyboard appears on screen.
 * After testing, the cleanest solution was to detect focus event on input tag then set the 'keyboardShown' flag.
 */
const UnStyledMobileButtonWrapper: FunctionComponent<BoxProps> = ({ className, children }) => {
  const mobileButtonWrapperRef = useRef<HTMLDivElement | null>(null);

  return (
    <div className={className} ref={mobileButtonWrapperRef}>
      <Box className={'mobileNoFloating'} mb={0}>
        {children}
      </Box>
    </div>
  );
};

export const MobileButtonWrapper = styled(UnStyledMobileButtonWrapper)`
  .mobileNoFloating {
    position: inherit;
    display: flex;
  }
`;
